/* eslint-disable react/no-array-index-key */
import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';

import {
  dataProtectionIcon,
  TLSIcon,
  DPLIcon,
  logoIcon,
} from 'assets/images';

import { useScreenWidth } from 'hooks';
import { ScreenWidth } from 'appConstants';
import { soon, data } from './data';

import styles from './styles.module.scss';

export const WorkAllDeviceContainer = memo(() => {
  const { t } = useTranslation('welcome');
  const isTablet = useScreenWidth(ScreenWidth.tablet);

  const carousel = useMemo(() => {
    const settings = {
      infinite: true,
      slidesToShow: isTablet ? 4 : 5,
      slidesToScroll: 1,
      autoplay: true,
      speed: 2000,
      autoplaySpeed: 2000,
      cssEase: 'linear',
    };

    return (
      <Slider {...settings}>
        {data.map(({ name, icon }, index) => (
          <div
            key={index}
            className={styles.each_platform_container}
          >
            <img
              alt=""
              src={icon}
              loading="lazy"
            />
            <span>{t(name)}</span>
          </div>
        ))}
      </Slider>
    );
  }, [isTablet, t]);

  const advantages = useMemo(() => {
    const advantageData = [
      {
        id: 1,
        img: dataProtectionIcon,
        text: t('Work_all_subcard_1_'),
      },
      {
        id: 2,
        img: TLSIcon,
        text: t('Work_all_subcard_2_'),
      },
      {
        id: 3,
        img: DPLIcon,
        text: t('Work_all_subcard_3_'),
      },
    ];

    return (
      <div className={styles.work_advantage_container}>
        {advantageData.map(({ id, img, text }) => (
          <div
            key={id}
            className={styles.each_advantage}
          >
            <img
              alt=""
              src={img}
              loading="lazy"
            />
            <p>{text}</p>
          </div>
        ))}
      </div>
    );
  }, [t]);

  const comingSoon = useMemo(() => (
    <div className={styles.soon_container}>
      {soon.map((item) => (
        <div
          className={styles.each_soon_item}
          key={item}
        >
          <img
            alt=""
            src={logoIcon}
            loading="lazy"
          />
          <p>{t(item)}</p>
        </div>
      ))}
    </div>
  ), [t]);

  return (
    <div className={styles.work_container}>
      <div className={styles.work_title_container}>
        <p>{t('Work_all_title_')}</p>
        <span>{t('Work_all_title_part2_')}</span>
      </div>
      {carousel}
      {advantages}

      <div className={styles.work_soon_title_container}>
        <p>{t('Soon_title_')}</p>
      </div>
      {comingSoon}
    </div>
  );
});
